<script>
import moment from "moment";
export default {
  data() {
    return {
      tableData: []
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const systemLog = sessionStorage.getItem("systemLog");
      //   console.log('-->>>', systemLog)
      if (systemLog) {
        const logData = JSON.parse(systemLog);
        console.log("logData-->>>", logData);
        this.tableData = logData.data;
      }
    },
    createdAtFormtter(row) {
      return moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss");
    }
  }
};
</script>
<template>
  <div class="trainLogsIndex">
    <el-table
      :data="tableData"
      class="accountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="type" align="left" label="类型" width="75">
        <template slot-scope="scope">
          <img v-if="scope.row.type === 'error'" class="logIcon" src="@/assets/logError.png" />
          <img
            v-else-if="scope.row.type === 'warning'"
            class="logIcon"
            src="@/assets/logWarning.png"
          />
          <img v-else class="logIcon" src="@/assets/logInfo.png" />
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        align="left"
        :formatter="createdAtFormtter"
        label="创建时间"
        width="180"
      ></el-table-column>
      <el-table-column prop="data" align="left" label="日志内容"></el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss" scoped>
@import "@/css/color.scss";

.trainLogsIndex {
  padding: 15px;
  .accountTable {
    margin: 10px auto;
    border: 1px;
    width: 98%;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
    .logIcon {
      width: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userinfo/systemLog.vue